import { Store } from "../uidispatcherapi/Store";
import HeaderActions from "../actions/HeaderActions";
const NO_HEADER_URLS = [
	"/backoffice",
	"/orderentry",
	"/order-entry",
	"/featureToggling",
	"/print",
	"/failed-submits",
	"/ordercapture/support-tool",
	"/backend/ordercapture",
];

class HeaderStoreImpl extends Store {
	_IsNoHeader: boolean;

	constructor() {
		super();
		this._IsNoHeader = false;
		this.listenTo(HeaderActions.updateHeader, this.updatePageHeader);
	}

	updatePageHeader: (...args: Array<any>) => any = (): void => {
		if (this.isUrlNoHeader()) {
			this._IsNoHeader = true;
			this.trigger();
		} else if (this._IsNoHeader && !this.isUrlNoHeader()) {
			this._IsNoHeader = false;
			this.trigger();
		}
	};

	isUrlNoHeader(): boolean {
		const url = window.location.href;
		return NO_HEADER_URLS.some(part => url.includes(part));
	}

	getIsNoHeader(): boolean {
		if (this.isUrlNoHeader()) {
			this._IsNoHeader = true;
		}

		return this._IsNoHeader;
	}
}

export const HeaderStore = new HeaderStoreImpl() as HeaderStoreImpl;
